
















































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import TwoColumnLayout from '@/components/TwoColumnLayout.vue'
import AsidePlaceholder from '@/components/AsidePlaceholder.vue'
import CoreButton from '@/components/CoreButton.vue'
import GoBackButton from '@/components/GoBackButton.vue'
import { Routes } from '@/router'

@Component({
    components: {
        TwoColumnLayout,
        AsidePlaceholder,
        CoreButton,
        VuePerfectScrollbar,
        GoBackButton,
    },
})
export default class TermsAndConditionsPage extends Vue {
    public routes = Routes

    public mounted() {
        window.scrollTo(0, 0)
    }
}
